export const HOME_JSONLD = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": "https://pogspirits.com/#website",
      "url": "https://pogspirits.com/",
      "name": "POG Spirits",
      "description": "POG Spirits — an independent spirits brand created in partnership with Meadow Gold. POG Vodka and POG Spiked Island Punch RTD. Distributed across Hawai‘i by Reyes / Island Distributing.",
      "inLanguage": "en-US",
      "publisher": {
        "@id": "https://pogspirits.com/#organization"
      }
    },
    {
      "@type": "Organization",
      "@id": "https://pogspirits.com/#organization",
      "name": "POG Spirits",
      "legalName": "POG Spirits",
      "url": "https://pogspirits.com/",
      "logo": {
        "@type": "ImageObject",
        "url": "https://pogspirits.com/brand/pog-logo.png",
        "width": 1497,
        "height": 907
      },
      "image": "https://pogspirits.com/og-image.jpg",
      "description": "POG Spirits is an independent Hawaiian spirits brand launching in 2026, created in partnership with Meadow Gold and inspired by the 1971 POG (Passion Orange Guava) juice. Features POG Vodka 750ml and POG Spiked Island Punch RTD. Distributed across Hawai‘i by Reyes / Island Distributing.",
      "foundingDate": "2026",
      "makesOffer": {
        "@type": "Offer",
        "areaServed": {
          "@type": "State",
          "name": "Hawai‘i, USA"
        },
        "seller": {
          "@type": "Organization",
          "name": "Reyes / Island Distributing",
          "description": "Exclusive Hawai‘i distributor for POG Spirits."
        }
      },
      "areaServed": [
        {
          "@type": "AdministrativeArea",
          "name": "Hawai‘i, USA"
        },
        {
          "@type": "AdministrativeArea",
          "name": "California, USA"
        },
        {
          "@type": "AdministrativeArea",
          "name": "Nevada, USA"
        }
      ],
      "sameAs": [
        "https://www.instagram.com/pogspirits"
      ]
    },
    {
      "@type": "Brand",
      "@id": "https://pogspirits.com/#brand",
      "name": "POG",
      "alternateName": [
        "POG Spirits",
        "Passion Orange Guava"
      ],
      "logo": "https://pogspirits.com/brand/pog-logo.png",
      "description": "POG Spirits — an independent spirits brand created in partnership with Meadow Gold, inspired by the iconic 1971 Hawaiian POG (Passion Orange Guava) juice.",
      "slogan": "Icons evolve. So we did."
    },
    {
      "@type": "Thing",
      "additionalType": "https://schema.org/Product",
      "@id": "https://pogspirits.com/#product-vodka",
      "name": "POG Vodka",
      "alternateName": [
        "POG Island Punch Vodka",
        "Passion Orange Guava Vodka"
      ],
      "description": "POG Vodka 750ml Glass — 35% ABV (70 proof) vodka flavored with real passion fruit, orange, and guava. An independent spirits brand created in partnership with Meadow Gold. Bottled by NLV Bottling, North Las Vegas, NV. Volume 750 ml; ABV 35% (70 proof); glass bottle.",
      "image": "https://pogspirits.com/products/pog-vodka.jpg",
      "brand": {
        "@id": "https://pogspirits.com/#brand"
      },
      "url": "https://pogspirits.com/#products"
    },
    {
      "@type": "Thing",
      "additionalType": "https://schema.org/Product",
      "@id": "https://pogspirits.com/#product-rtd",
      "name": "POG Spiked Island Punch",
      "alternateName": [
        "POG Spike Island Punch",
        "POG RTD",
        "POG Ready-to-Drink Punch"
      ],
      "description": "POG Spiked Island Punch — 11.5 fl oz (340 ml) can at 6% ABV. Sparkling flavored beverage with real passion fruit juice, guava purée, orange juice, and organic cane sugar; 160 calories. Produced by Hawaiian Ola Brewing Corporation, Kailua-Kona, HI.",
      "image": "https://pogspirits.com/products/pog-can.jpg",
      "brand": {
        "@id": "https://pogspirits.com/#brand"
      },
      "url": "https://pogspirits.com/#products"
    },
    {
      "@type": "FAQPage",
      "@id": "https://pogspirits.com/#faq",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is POG?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "POG stands for Passion fruit, Orange, and Guava — a beloved Hawaiian juice blend invented at Meadow Gold in 1971. It became one of the most recognized regional flavors in the Pacific and is now the foundation of the POG Spirits brand."
          }
        },
        {
          "@type": "Question",
          "name": "What is POG Vodka?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "POG Vodka is a 750 ml premium vodka at 35% alcohol by volume (70 proof), flavored with real passion fruit, orange, and guava. It is part of the POG Spirits launch — an independent spirits brand created in partnership with Meadow Gold — in 2026."
          }
        },
        {
          "@type": "Question",
          "name": "What is POG Spiked Island Punch?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "POG Spiked Island Punch is a ready-to-drink sparkling flavored beverage in an 11.5 fl oz (340 ml) can at 6% ABV, made with real passion fruit juice, guava purée, orange juice, sparkling water, and organic cane sugar. It contains 160 calories per can."
          }
        },
        {
          "@type": "Question",
          "name": "Where is POG Spirits made?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "POG Spirits is made in Hawai‘i. The Spiked Island Punch RTD is produced by Hawaiian Ola Brewing Corporation in Kailua-Kona, Hawai‘i. POG Vodka is bottled by NLV Bottling in North Las Vegas, Nevada."
          }
        },
        {
          "@type": "Question",
          "name": "When does POG Spirits launch?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "POG Spirits launches in 2026, beginning in Hawai‘i across O‘ahu, Maui, the Big Island, and Kaua‘i, then rolling out to the U.S. West Coast (California and Nevada)."
          }
        },
        {
          "@type": "Question",
          "name": "Where can I buy POG Vodka and POG Punch?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "POG Vodka and POG Spiked Island Punch will be available across Hawai‘i in 2026 through Reyes and Island Distributing — major grocers, retail chains, resorts, and premium bars — then rolling out to California and Nevada. Wholesale and retailer inquiries are welcomed via the POG Spirits contact form."
          }
        },
        {
          "@type": "Question",
          "name": "How is POG Spirits related to POG juice?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "POG juice was invented at Meadow Gold in Hawai‘i in 1971. POG Spirits is an independent spirits brand launching in 2026, created in partnership with Meadow Gold and inspired by that original flavor — honoring it with real passion fruit, orange, and guava."
          }
        },
        {
          "@type": "Question",
          "name": "Is POG Vodka gluten-free?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "POG Vodka is a neutral vodka flavored with real fruit. The POG Spiked Island Punch RTD uses alcohol fermented from organic sugar (not grain). For specific allergen questions, please contact POG Spirits directly."
          }
        },
        {
          "@type": "Question",
          "name": "Who owns POG Spirits?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "POG Spirits is an independent spirits brand, created in partnership with Meadow Gold. Meadow Gold — the historic Hawaiian beverage house founded in 1897 — invented the original POG (Passion Orange Guava) juice in 1971 and holds the POG trademark in Hawai‘i."
          }
        },
        {
          "@type": "Question",
          "name": "What does POG Vodka taste like?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "POG Vodka has a bright, tropical-inspired profile: passion fruit blossom and ripe orange peel on the nose, soft guava and clean grain on the palate with a whisper of sea salt, and a crisp, dry finish."
          }
        }
      ]
    },
    {
      "@type": "HowTo",
      "@id": "https://pogspirits.com/#howto-kailua-sunset",
      "name": "The Kailua Sunset — POG Vodka Cocktail",
      "description": "A refreshing rocks-style cocktail built with POG Vodka, fresh lime, and orgeat, topped with soda and a burnt orange peel.",
      "totalTime": "PT3M",
      "yield": "1 cocktail",
      "recipeCuisine": "Hawaiian",
      "tool": [
        {
          "@type": "HowToTool",
          "name": "Rocks glass"
        },
        {
          "@type": "HowToTool",
          "name": "Large ice cube"
        }
      ],
      "supply": [
        {
          "@type": "HowToSupply",
          "name": "2 oz POG Vodka"
        },
        {
          "@type": "HowToSupply",
          "name": "3/4 oz fresh lime juice"
        },
        {
          "@type": "HowToSupply",
          "name": "1/2 oz orgeat"
        },
        {
          "@type": "HowToSupply",
          "name": "Soda water"
        },
        {
          "@type": "HowToSupply",
          "name": "Burnt orange peel"
        }
      ],
      "step": [
        {
          "@type": "HowToStep",
          "text": "Build POG Vodka, lime juice and orgeat over a large ice cube in a rocks glass."
        },
        {
          "@type": "HowToStep",
          "text": "Stir gently and top with soda water."
        },
        {
          "@type": "HowToStep",
          "text": "Express a burnt orange peel over the glass and drop it in. Serve at golden hour."
        }
      ]
    },
    {
      "@type": "HowTo",
      "@id": "https://pogspirits.com/#howto-lei-day-spritz",
      "name": "Lei Day Spritz — POG Vodka Spritz",
      "description": "A sparkling POG Vodka spritz with passion fruit cordial and guava nectar over crushed ice.",
      "totalTime": "PT2M",
      "yield": "1 cocktail",
      "supply": [
        {
          "@type": "HowToSupply",
          "name": "1 1/2 oz POG Vodka"
        },
        {
          "@type": "HowToSupply",
          "name": "3 oz dry sparkling wine"
        },
        {
          "@type": "HowToSupply",
          "name": "3/4 oz passion fruit cordial"
        },
        {
          "@type": "HowToSupply",
          "name": "Splash of guava nectar"
        },
        {
          "@type": "HowToSupply",
          "name": "Edible orchid"
        }
      ],
      "step": [
        {
          "@type": "HowToStep",
          "text": "Build all liquids over crushed ice in a chilled wine glass."
        },
        {
          "@type": "HowToStep",
          "text": "Stir once to combine."
        },
        {
          "@type": "HowToStep",
          "text": "Garnish with an edible orchid and half a passion fruit."
        }
      ]
    },
    {
      "@type": "HowTo",
      "@id": "https://pogspirits.com/#howto-big-island-punch",
      "name": "Big Island Punch — POG Spiked Punch Cocktail",
      "description": "A tiki-style punch built on a can of POG Spiked Island Punch with a shot of POG Vodka and Angostura bitters.",
      "totalTime": "PT2M",
      "yield": "1 tiki mug",
      "supply": [
        {
          "@type": "HowToSupply",
          "name": "1 can POG Spiked Island Punch"
        },
        {
          "@type": "HowToSupply",
          "name": "1 oz POG Vodka"
        },
        {
          "@type": "HowToSupply",
          "name": "1/2 oz fresh lime juice"
        },
        {
          "@type": "HowToSupply",
          "name": "3 dashes Angostura bitters"
        },
        {
          "@type": "HowToSupply",
          "name": "Mint bouquet"
        }
      ],
      "step": [
        {
          "@type": "HowToStep",
          "text": "Fill a tiki mug with pebble ice."
        },
        {
          "@type": "HowToStep",
          "text": "Add POG Vodka, lime juice and Angostura bitters."
        },
        {
          "@type": "HowToStep",
          "text": "Top with the chilled POG Spiked Island Punch RTD, stir once, and garnish with a mint bouquet."
        }
      ]
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://pogspirits.com/#breadcrumbs",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://pogspirits.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Story",
          "item": "https://pogspirits.com/#story"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Products",
          "item": "https://pogspirits.com/#products"
        },
        {
          "@type": "ListItem",
          "position": 4,
          "name": "Cocktails",
          "item": "https://pogspirits.com/#cocktails"
        },
        {
          "@type": "ListItem",
          "position": 5,
          "name": "Press",
          "item": "https://pogspirits.com/#press"
        },
        {
          "@type": "ListItem",
          "position": 6,
          "name": "Inquire",
          "item": "https://pogspirits.com/#inquire"
        }
      ]
    }
  ]
};
